import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/analysis` is now folded into the suggestion queues — the
 * meeting-transcript analyser lives alongside the work-item queue. Kept as a
 * redirect so old links / bookmarks still land in the right place.
 */
export const Route = createFileRoute("/_app/analysis/")({
  beforeLoad: () => {
    throw redirect({ to: "/suggestions/work-items" });
  },
});
